import scrollLock from 'scroll-lock';

export default class Menu {
	constructor() {
		this.header = document.querySelector('[data-site-header]');
		this.hamburger = document.querySelector('[data-hamburger]');
		this.menu = document.querySelector('[data-main-menu]');

		if (!this.menu) {
			return;
		}

		this.menuItems = this.menu.querySelectorAll('[data-menu-item]');
		this.menuOpen = false;

		this.menuItems.forEach((item) => {
			item.addEventListener('mouseenter', (e) => {
				const button = e.target.querySelector('[data-dropdown-toggle]');

				button?.setAttribute('aria-expanded', true);
			});

			item.addEventListener('mouseleave', (e) => {
				const button = e.target.querySelector('[data-dropdown-toggle]');

				button?.setAttribute('aria-expanded', false);
			});

			// focusin, focusout
			// item.addEventListener('focusout', (e) => {
			// 	console.log('focusout', e);
			// });
		});

		this.hamburger.addEventListener('click', () => {
			this.toggleMenu();
		});
	}

	static init() {
		if (document.querySelector('[data-site-header]')) {
			new Menu();
		}
	}

	toggleMenu() {
		if (this.menuOpen) {
			this.closeMenu();
		} else {
			this.openMenu();
		}
	}

	openMenu() {
		scrollLock.disablePageScroll(this.menu);
		this.header.classList.add('menu-is-open');
		this.hamburger.classList.add('is-active');
		this.menuOpen = true;
	}

	closeMenu() {
		scrollLock.enablePageScroll(this.menu);
		this.header.classList.remove('menu-is-open');
		this.hamburger.classList.remove('is-active');
		this.menuOpen = false;
	}
}
